import toggleView from "./components/toggleView";
import initPlanPanZoom from "./components/panzoom";
import objectPlanScripts from "./components/objectPlanSelection";
import objectItemsData from "./components/objectItemsData";
import initBuilderViews from "./components/builderViews";
import builderExtras from "./components/builderExtras";
import updateTotalPriceLogic from "./components/updatePrice";
import NanoModal from "./components/modal";
import showSelectedItems from "./components/selectedItemsModal";
import smScreenViews from "./components/smScreenViews";
import moveProgressSection from "./components/moveProgress";
import tippy from "tippy.js";
import objectFurnitureData from "./components/objectFurnitureData";
import showSelectedFurniture from "./components/selectedFurnitureModal";
import addAccordion from "./components/accordion";
import packageSelection from "./components/packageSelection";
import warrantyRequests from "./components/warrantyRequests";
import mobileMenu from "./components/mobileMenu";
import objectOffers from "./components/objectOffers";

function runOnLoadAndDocumentReady() {
  showSelectedItems();
  showSelectedFurniture();
  smScreenViews();
  moveProgressSection();
  addAccordion();
  mobileMenu();

  function extraInfoTippy() {
    const tippyElements = document.querySelectorAll("#tippyExtraInfo, .tippy-extra-info, [data-tippy-content]");
    if (tippyElements.length === 0) {
      return;
    }

    tippyElements.forEach((tippyElement) => {
      const tippyContent = tippyElement.dataset.tippyContent;
      if (!tippyContent) {
        return;
      }

      // Per-element trigger override via data-tippy-trigger (any tippy-supported trigger string).
      // Defaults to hover/focus; "click" keeps the tooltip open when the "?" is clicked (instead of
      // tippy's hideOnClick closing it) and makes touch devices tap-to-open, tap-outside-to-close.
      const triggerAttr = tippyElement.dataset.tippyTrigger;
      const trigger = triggerAttr ? triggerAttr : "mouseenter focus click";
      // Hover tooltips shouldn't be interactive (prevents stuck-open state when cursor leaves).
      const interactive = trigger === "click";

      tippy(tippyElement, {
        content: tippyContent,
        allowHTML: true,
        interactive,
        arrow: true,
        // "?" icons (no explicit trigger) keep their original bottom-start placement.
        placement: triggerAttr ? "bottom" : "bottom-start",
        trigger,
        theme: "light",
      });
    });
  }

  function checkForPlanPanZoomElements() {
    if (document.querySelector(".js-panzoom-wrap")) {
      initPlanPanZoom();
    }
  }

  function initMainApplication() {
    checkForPlanPanZoomElements();
    extraInfoTippy();

    // Initialize core modules
    toggleView();
    initBuilderViews();
    updateTotalPriceLogic();

    // Initialize selection managers
    objectItemsData();
    objectFurnitureData();
    objectPlanScripts();
    builderExtras();
    packageSelection();
    warrantyRequests();
    objectOffers();
  }

  // Global notification handler
  const notifications = document.querySelectorAll(
    ".js-close-notification, .notification-close"
  );
  notifications.forEach((notification) => {
    notification.addEventListener("click", () => {
      const notificationContainer = notification.closest("[data-notification]");
      if (notificationContainer) {
        notificationContainer.classList.remove("active");
      } else {
        notification.closest(".main-notification")?.classList.remove("active");
      }
    });
  });

  // Global modal triggers
  const modalTriggers = document.querySelectorAll("[data-modal-trigger]");
  modalTriggers.forEach((trigger) => {
    const targetModal = document.querySelector(
      "#" + trigger.getAttribute("data-modal-trigger")
    );
    if (targetModal) {
      const modal = new NanoModal(targetModal);
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        modal.showModal();
      });
    }
  });

  // Contact modal triggers
  const contactModalTriggers = document.querySelectorAll(".js-contact-modal");
  contactModalTriggers.forEach((trigger) => {
    const targetModalId = trigger.getAttribute("aria-controls");
    const targetModal = document.querySelector("#" + targetModalId);
    if (targetModal) {
      const modal = new NanoModal(targetModal, {
        onShow: () => {
          contactModalTriggers.forEach((trigger) => {
            trigger.setAttribute("aria-expanded", "true");
          });
        },
        onClose: () => {
          contactModalTriggers.forEach((trigger) => {
            trigger.setAttribute("aria-expanded", "false");
          });
        }
      });
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        modal.showModal();
      });
    }
  });

  initMainApplication();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runOnLoadAndDocumentReady);
} else {
  runOnLoadAndDocumentReady();
}
